function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Immutable from 'seamless-immutable';
import NavigatorActions from 'invision-core/src/components/navigator/navigator.actions';
import { MOBILE_NUMBER_PORTABILITY_FORM_VALIDATED, MOBILE_NUMBER_PORTABILITY_SET_EDIT_ADDITIONAL_PROPERTY, MOBILE_NUMBER_PORTABILITY_SET_EDIT_ADDITIONAL_PROPERTY_ON_CHANGE, RESET_MOBILE_NUMBER_PORTABILITY_MODELS, RESET_PORTABILITY_MODEL, RESTORE_PORTABILITY_ATTRIBUTE, SAVE_PORTABILITY_ATTRIBUTE, SET_SHOW_PORTABILITY, UPDATE_MOBILE_NUMBER_PORTABILITY_ADDRESS_MODEL, UPDATE_MOBILE_NUMBER_PORTABILITY_MODEL } from './../actions/mobile.number.portability.actions';
import { RESUME_ORDER_ATTRIBUTES } from '../actions/add.offer.wizard.actions';
import { RETRIEVE_ATTRIBUTES } from '../actions/offering.order.actions';
import { mapAdditionalProperty, setEditAp } from '../helpers/customer.helper';
export var INITIAL_STATE = Immutable({
  portabilityModel: {
    existingNumber: null,
    provider: null,
    accountNumber: null,
    token: null,
    mnpAdditionalProps: []
  },
  addressModel: {
    LineOne: null,
    LineTwo: null,
    Country: null,
    City: null,
    State: null,
    PostalCode: null
  },
  lastValidatedAddress: {
    LineOne: null,
    LineTwo: null,
    Country: null,
    City: null,
    State: null,
    PostalCode: null
  },
  savedPortabilityAttributes: {},
  showPortability: false,
  isResumingCartWithMnpData: false
});
export default function MobileNumberPortabilityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type,
    requestObject = _ref.requestObject;
  switch (type) {
    case UPDATE_MOBILE_NUMBER_PORTABILITY_MODEL:
      return state.setIn(['portabilityModel'], payload);
    case UPDATE_MOBILE_NUMBER_PORTABILITY_ADDRESS_MODEL:
      return state.setIn(['addressModel'], payload);
    case RESET_PORTABILITY_MODEL:
      return state.setIn(['portabilityModel'], INITIAL_STATE.portabilityModel);
    case RESET_MOBILE_NUMBER_PORTABILITY_MODELS:
      return INITIAL_STATE;
    case MOBILE_NUMBER_PORTABILITY_FORM_VALIDATED:
      return state.setIn(['lastValidatedAddress'], state.addressModel);
    case SET_SHOW_PORTABILITY:
      return state.setIn(['showPortability'], payload);
    case SAVE_PORTABILITY_ATTRIBUTE:
      return state.setIn(['savedPortabilityAttributes', payload.attributeId], Immutable({
        addressModel: state.addressModel,
        portabilityModel: state.portabilityModel,
        showPortability: state.showPortability
      }));
    case RESTORE_PORTABILITY_ATTRIBUTE:
      if (!state.savedPortabilityAttributes[payload]) {
        return INITIAL_STATE.setIn(['savedPortabilityAttributes'], state.savedPortabilityAttributes).setIn(['addressModel'], state.lastValidatedAddress).setIn(['lastValidatedAddress'], state.lastValidatedAddress);
      }
      return state.setIn(['addressModel'], state.savedPortabilityAttributes[payload].addressModel).setIn(['portabilityModel'], state.savedPortabilityAttributes[payload].portabilityModel).setIn(['showPortability'], state.savedPortabilityAttributes[payload].showPortability);
    case MOBILE_NUMBER_PORTABILITY_SET_EDIT_ADDITIONAL_PROPERTY:
      return state.setIn(['portabilityModel', 'mnpAdditionalProps'], mapAdditionalProperty(payload));
    case MOBILE_NUMBER_PORTABILITY_SET_EDIT_ADDITIONAL_PROPERTY_ON_CHANGE:
      return state.setIn(['portabilityModel', 'mnpAdditionalProps'], setEditAp(payload, state.portabilityModel.mnpAdditionalProps));
    case RETRIEVE_ATTRIBUTES.SUCCESS:
      {
        return requestObject && requestObject.changeOfferingInstanceId ? state.setIn(['savedPortabilityAttributes'], populateMnpAttributes(payload.Context.ValueDecisions)).setIn(['showPortability'], INITIAL_STATE.showPortability).setIn(['isResumingCartWithMnpData'], !!getMnpAttributes(payload.Context.ValueDecisions).length) : state;
      }
    case RESUME_ORDER_ATTRIBUTES.SUCCESS:
      return state.setIn(['savedPortabilityAttributes'], populateMnpAttributes(payload.Context.ValueDecisions)).setIn(['showPortability'], INITIAL_STATE.showPortability).setIn(['isResumingCartWithMnpData'], !!getMnpAttributes(payload.Context.ValueDecisions).length);
    case NavigatorActions.STATE_CHANGE_SUCCESS:
      return INITIAL_STATE;
    default:
      return state;
  }
}
function getMnpAttributes(valueDecisions) {
  return valueDecisions.filter(function (attribute) {
    return attribute.IsPortable && attribute.PortInRequest;
  });
}
function populateMnpAttributes(valueDecisions) {
  var portInRequests = {};
  var updatedDecisions = getMnpAttributes(valueDecisions);
  var updatedAttributes = updatedDecisions.map(function (item) {
    return Object.assign({}, item, {
      portabilityModel: {
        existingNumber: item.PortInRequest.PortInNumber,
        provider: item.PortInRequest.ServiceProviderId.toString(),
        token: item.PortInRequest.ValidationToken,
        mnpAdditionalProps: item.PortInRequest.AdditionalProperties || []
      },
      showPortability: true,
      addressModel: item.PortInRequest.Address
    });
  });
  updatedAttributes.forEach(function (item) {
    Object.assign(portInRequests, _defineProperty({}, item.Id, item));
  });
  return portInRequests;
}